module.exports = __webpack_public_path__ + "webfonts/lg.eot";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/fonts/lg.eot
// module id = 517
// module chunks = 64 65